import { render, staticRenderFns } from "./serviceprice.vue?vue&type=template&id=7ee7fb16&"
import script from "./serviceprice.vue?vue&type=script&lang=js&"
export * from "./serviceprice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee7fb16')) {
      api.createRecord('7ee7fb16', component.options)
    } else {
      api.reload('7ee7fb16', component.options)
    }
    module.hot.accept("./serviceprice.vue?vue&type=template&id=7ee7fb16&", function () {
      api.rerender('7ee7fb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25NPdww4xu75f/JS/serviceprice.vue"
export default component.exports